import Observer from '../classes/Observer';

class LazyVideos extends Observer {
  constructor() {
    super({
      isOnce: true,
      rootMargin: '200px 0px',
    });

    const $targets = $('iframe[data-lazy-vimeo][data-src]');

    if (!$targets.length) return;

    this.observe($targets);
  }

  animateIn(target: Element) {
    super.animateIn(target);

    const $target = $(target);

    if ($target.is('video')) {
      const $sources = $target.find('source[data-src]');
      $sources.each((_, source) => {
        const deferredSrc = source.dataset.src;
        if (deferredSrc) {
          source.src = deferredSrc;
          source.removeAttribute('data-src');
        }
      });
      ($target.get(0) as HTMLVideoElement).load();
      return;
    }

    const iframe = $target.get(0) as HTMLIFrameElement | undefined;
    const deferredSrc = iframe?.dataset.src;

    if (!iframe || !deferredSrc || iframe.src) return;

    iframe.src = deferredSrc;
    iframe.removeAttribute('data-src');
  }
}

export default LazyVideos;
